import { Component, OnInit } from '@angular/core';
import { AuthorizeService } from '../authorize.service';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { Role } from '../../app/_models/role';

@Component({
  selector: 'app-login-menu',
  templateUrl: './login-menu.component.html',
  styleUrls: ['./login-menu.component.css']
})
export class LoginMenuComponent implements OnInit {
  public isAuthenticated: Observable<boolean>;
  //public userName: Observable<string>;
  public isAdmin: Observable<boolean>;

  constructor(private authorizeService: AuthorizeService) { }

  ngOnInit() {
    this.isAuthenticated = this.authorizeService.isAuthenticated();
    //this.userName = this.authorizeService.getUser().pipe(map(u => u && u.name));
    this.isAdmin = this.authorizeService.getUser().pipe(map(u => u && u.role && (u.role.includes(Role.Developer)  || u.role.includes(Role.Administrator))));
  }
}
